import { Component } from '@angular/core';
import { PageShell } from '@shared/components/page-shell/page-shell';
import { ListPlaceholder } from '@shared/components/list-placeholder/list-placeholder';

@Component({
  selector: 'app-reports-list',
  imports: [PageShell, ListPlaceholder],
  template: `
    <app-page-shell
      title="Reports"
      description="Operational analytics, exports, and platform usage reports."
      badge="Analytics"
    >
      <app-list-placeholder
      [columns]="[
        { key: 'report', label: 'Report', width: '30%' },
        { key: 'category', label: 'Category', width: '18%' },
        { key: 'period', label: 'Period', width: '16%' },
        { key: 'generated', label: 'Generated', width: '18%' },
      ]"
      emptyTitle="No reports available"
      emptyMessage="Generated reports and analytics exports will appear here once reporting is connected."
      />
    </app-page-shell>
  `,
})
export class ReportsList {}
